define('views/parts/list/fetch-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/parts/fetch-button',
    // templates
    'text!templates/parts/list/fetch-list.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VFetchButton,
    // templates
    TList
) {

    var _extend = _.extend,
        _defaults = _.defaults;

    var VFetchList = VList.extend({
        template: TList,
        regions: {
            list: ".list-items",
            more: ".load-button",
        },

        computeds: {
            // bind the collection's total count indicated by the server.
            collectionTotal: {
                deps: ["$collection", ],
                get: function(collection) {
                    return collection.getTotal ? collection.getTotal() : collection.length;
                },
            }
        },

        constructor: function(opt) {
            var proto = VFetchList.prototype;
            this.regions = _defaults({}, this.regions, proto.regions);
            this.computeds = _defaults({}, this.computeds, proto.computeds);
            VFetchList.__super__.constructor.apply(this, arguments);
        },

        initialize: function(opt) {
            var options = this.options = _extend({
                async: true,
            }, opt);
            if (options.async) {
                this.view = {
                    more: new VFetchButton(_extend({
                        label: 'Show more',
                        callback: this.onLoadMore,
                        context: this,
                        icon: 'sl-icon-arrow-down',
                    }, options.button)),
                };
            }
        },

        render: function() {

            VFetchList.__super__.render.apply(this, arguments);
            if (this.options.async) {
                this.assign(this.view.more, this.zone.$more);
            }
            return this;
        },

        renderAll: function(models, opt) {
            VFetchList.__super__.renderAll.call(this, models);
            if (this.options.async) this._updateMoreButton();

            return this;
        },

        getItemOptions: function(options) {
            return _.extend(options, this.options.itemOptions);
        },

        _updateMoreButton: function() {
            this.view.more.toggle(this.collection.hasLeft());
        },

        ////////////
        // events //
        ////////////
        onLoadMore: function(e, callback) {
            this.collection.getNextPage({ fetch: true }).always(callback);
        },
    });

    return VFetchList;
});

